export default "__VITE_ASSET__D$_z17kZ__"